import Vue from 'vue'
import Router from 'vue-router'
const Service = resolve => import('@/components/xfx_service/service').then(module => resolve(module))
const CreateXHS = resolve => import('@/components/create/xhs').then(module => resolve(module))
const CreateDY = resolve => import('@/components/create/dy').then(module => resolve(module))
const CreateKS = resolve => import('@/components/create/ks').then(module => resolve(module))
const CreateLZ = resolve => import('@/components/create/lz').then(module => resolve(module))
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {path: '/create_lz', component: CreateLZ},
    {path: '/create_ks', component: CreateKS},
    {path: '/create_dy', component: CreateDY},
    {path: '/create_xhs', component: CreateXHS},
    {path: '/xfx_service', component: Service},
  ]
})
